import { Watcher } from './Watcher.js';
export const SELECTABLE_DEFINITIONS = [];
export const PERSISTENT_DEFINITIONS = [];
export const DESCRIPTIONS = [];
/**
 * Debug Layer Decorators.
 */
export class Debug {
    /**
     * Defines a class as a Persistant.
     */
    static Persistent(config = {}) {
        return function (constructor) {
            PERSISTENT_DEFINITIONS.push({ type: constructor, config: config });
            class Persistent extends constructor {
                constructor(...args) {
                    super(...args);
                    this.__self = this;
                    Watcher.notify_created(this.__self);
                }
                dispose(...args) {
                    Watcher.notify_disposed(this.__self);
                    super.dispose(...args);
                }
            }
            return Persistent;
        };
    }
    /**
     * Defines a class as a Selectable.
     */
    static Selectable(config) {
        return function (constructor) {
            SELECTABLE_DEFINITIONS.push({ type: constructor, config: config });
            class Selectable extends constructor {
                constructor(...args) {
                    super(...args);
                    this.__self = this;
                    Watcher.notify_created(this.__self);
                }
                dispose(...args) {
                    Watcher.notify_disposed(this.__self);
                    super.dispose(...args);
                }
            }
            return Selectable;
        };
    }
    /**
     * Describes a class for the debug layer.
     */
    static Describe(description) {
        return function (constructor) {
            DESCRIPTIONS.push(Object.assign({ type: constructor }, description));
        };
    }
    /**
     * Property.
     *
     * Creates a watcher for a decorated property.
     */
    static Property(config = {}) {
        return function (target, property_key, descriptor) {
            var _a, _b;
            const setup = (tab, instance) => {
                if (!config.if || config.if(instance)) {
                    tab.watch(instance, property_key, {
                        name: typeof config.name === 'function' ? config.name(instance) : config === null || config === void 0 ? void 0 : config.name,
                        is_readonly: config === null || config === void 0 ? void 0 : config.is_readonly
                    });
                }
            };
            const tab_tag = (_a = config.tab) !== null && _a !== void 0 ? _a : to_text(target.constructor.name);
            const description = {
                type: target.constructor,
                name: (_b = config.tag) !== null && _b !== void 0 ? _b : 'decorated: ' + property_key,
                is_enabled: true,
                initiate_tabs: [{
                        tag: tab_tag,
                        setup: setup,
                        dependencies: config.if
                            ? (instance) => {
                                return [() => config.if(instance)];
                            }
                            : undefined
                    }]
            };
            DESCRIPTIONS.push(description);
        };
    }
    /**
     * Button
     *
     * Creates a button for a decorated method.
     */
    static Button(config = {}) {
        return function (target, property_key, descriptor) {
            var _a, _b;
            const setup = (tab, instance) => {
                var _a;
                if (!config.if || config.if(instance)) {
                    const label = typeof config.name === 'function' ? config.name(instance) : (_a = config === null || config === void 0 ? void 0 : config.name) !== null && _a !== void 0 ? _a : property_key;
                    tab.button(label, { on_click: () => instance[property_key]() });
                }
            };
            const tab_tag = (_a = config.tab) !== null && _a !== void 0 ? _a : to_text(target.constructor.name);
            const description = {
                type: target.constructor,
                name: (_b = config.tag) !== null && _b !== void 0 ? _b : 'decorated: ' + property_key,
                is_enabled: true,
                initiate_tabs: [{
                        tag: tab_tag,
                        setup: setup,
                        dependencies: config.if
                            ? (instance) => {
                                return [() => config.if(instance)];
                            }
                            : undefined
                    }]
            };
            DESCRIPTIONS.push(description);
        };
    }
    /**
     * Setter
     *
     * Creates a setter for a decorated method.
     */
    static Setter(type, config) {
        return function (target, property_key, descriptor) {
            var _a, _b;
            const setup = (tab, instance) => {
                var _a;
                if (!config.if || config.if(instance)) {
                    const label = typeof config.name === 'function' ? config.name(instance) : (_a = config === null || config === void 0 ? void 0 : config.name) !== null && _a !== void 0 ? _a : property_key;
                    const initial_value = config.initial_value;
                    tab.setter(instance, property_key, initial_value, { name: label });
                }
            };
            const tab_tag = (_a = config.tab) !== null && _a !== void 0 ? _a : to_text(target.constructor.name);
            const description = {
                type: target.constructor,
                name: (_b = config.tag) !== null && _b !== void 0 ? _b : 'decorated: ' + property_key,
                is_enabled: true,
                initiate_tabs: [{
                        tag: tab_tag,
                        setup: setup,
                        dependencies: config.if
                            ? (instance) => {
                                return [() => config.if(instance)];
                            }
                            : undefined
                    }]
            };
            DESCRIPTIONS.push(description);
        };
    }
    /**
     * Getter
     *
     * Creates a getter for a decorated method.
     */
    static Getter(type, config = {}) {
        return function (target, property_key, descriptor) {
            var _a, _b;
            const setup = (tab, instance) => {
                var _a;
                if (!config.if || config.if(instance)) {
                    const label = typeof config.name === 'function' ? config.name(instance) : (_a = config === null || config === void 0 ? void 0 : config.name) !== null && _a !== void 0 ? _a : property_key;
                    tab.getter(instance, property_key, { name: label });
                }
            };
            const tab_tag = (_a = config.tab) !== null && _a !== void 0 ? _a : to_text(target.constructor.name);
            const description = {
                type: target.constructor,
                name: (_b = config.tag) !== null && _b !== void 0 ? _b : 'decorated: ' + property_key,
                is_enabled: true,
                initiate_tabs: [{
                        tag: tab_tag,
                        setup: setup,
                        dependencies: config.if
                            ? (instance) => {
                                return [() => config.if(instance)];
                            }
                            : undefined
                    }]
            };
            DESCRIPTIONS.push(description);
        };
    }
}
function to_text(str) {
    return str.replace(/([A-Z])/g, ' $1').trim();
}
//# sourceMappingURL=DebugDecorators.js.map